import React, { useEffect } from 'react'
import { useState } from "react"
import Logo from "../../assets/img/logo.png"
import Ilustration from "../../assets/img/ilustration.png"
import "./Login.scss"
import { useNavigate, useLocation, Link } from "react-router-dom"
import { jwtDecode } from "jwt-decode"
import { Oval } from 'react-loader-spinner'
import { Modal } from 'react-bootstrap';
import Modal2FA from "../../components/Modales/2FA/Modal2FA";

function Login() {
    const location = useLocation();

    const [formData, setFormData] = useState({
        email: "",
        password: ""
    })

    const [error, setError] = useState(null)
    const [fetchError, setFetchError] = useState(null)

    const [errors, setErrors] = useState({})

    const [loading, setLoading] = useState(false)

    const [modalPassword, setModalPassword] = useState(false)

    const [modalError, setModalError] = useState(false)

    const [modal2fa, setModal2fa] = useState(false)
    const [mfaData, setMfaData] = useState(null);
    const [activated, setActivated] = useState(false);
    const [modalMfaActivatedSuccessfully, setModalSuccess] = useState(false);
    const [jwt, setJwt] = useState("");

    const navigate = useNavigate()

    useEffect(()=>{
        if(localStorage.getItem("token")) {
            navigate("/inicio")
        }

        // Modal luego del cambio de contraseña
        if(location.state && location.state.codigo === 0){
            setFormData((prevState) => ({
                ...prevState,
                email: location.state.mail
            }))
            setModalPassword(true)
        }
        const timer = setTimeout(() => {
            setModalPassword(false);
        }, 5000);
        return () => clearTimeout(timer);

    // eslint-disable-next-line react-hooks/exhaustive-deps
    },[location.state])

    const handleChange = (e) => {
        const { name, value } = e.target
        setFormData({
            ...formData,
            [name]: value
        })
    }
    
    const validateForm = (data) => {
        const errors = {}

        if(!data.email.trim()){
            errors.email = "Escriba el mail."
        } else if (!/\S+@\S+\.\S+/.test(data.email)){
            errors.email = "El email no es válido."
        }
        if(!data.password.trim()) {
            errors.password = "Escriba su contraseña."
        }
        return errors;
    }
    
    const handleSubmit = async (e) => {
        e.preventDefault()
        const newErrors = validateForm(formData)
        setErrors(newErrors)
        if(Object.keys(newErrors).length === 0){
            setError(null)
            const reqBody = {
                mail: formData.email,
                pass: formData.password
            }
            try {
                setLoading(true)
                const res = await fetch(`${process.env.REACT_APP_API_URL}/apis/user/login`, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json"
                    },
                    body: JSON.stringify(reqBody)
                })
                const data = await res.json()
                const obj = jwtDecode(data)
                if(obj.apirest.status === 15){
                    setLoading(false)
                    navigate("/reset-password", {state: formData.email})
                } else if (obj.apirest.status === 0) {
                    setLoading(false)
                    successfulLogin(data);
                } else if (obj.apirest.status === 20) {
                    // No tiene activado 2FA
                    setLoading(false)
                    successfulLogin(data, true);
                } else if (obj.apirest.status === 25) {
                    setActivated(true);
                    setMfaData(obj.apirest.objeto); 
                    setJwt(data);
                    setModal2fa(true);
                    setLoading(false);
                } else {
                    // Incluyen error 10 (contraseña incorrecta)
                    // Incluye error 99 (usuario inactivo o prueba de test finalizada)
                    setLoading(false)
                    setError(obj.apirest.codeError)
                }
            } catch (error) {
                setLoading(false)
                setFetchError("Error en el backend. Intenta nuevamente.")
                setModalError(true)     
            }
        } else {
            setLoading(false)
            setError("Completar los campos mencionados.")
        }
    }

    const successfulLogin = (jwt, status = null) => {

        if ('credentials' in navigator && window.PasswordCredential) {
            /* global PasswordCredential */
            const cred = new PasswordCredential({
                id: formData.email,
                password: formData.password,
                name: formData.email
            })
            navigator.credentials.store(cred)
        }

        localStorage.setItem('token', JSON.stringify(jwt));

        if(status === true){
            const data = {
                codigo: 1
            }
            navigate("/home", { state: data });
            return;
        }
        navigate("/home");
    };

    const handleCloseError = () => {
        setModalError(false)
    }

    return (
        <>
            {modalError && <Modal show={modalError} onHide={handleCloseError} animation={false}>
                    <Modal.Header closeButton>
                        <Modal.Title>¡Ha ocurrido un problema!</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>{fetchError}</Modal.Body>
                </Modal>
            }
            {modalPassword && <Modal show={modalPassword} onHide={()=>setModalPassword(false)} animation={false}>
                <Modal.Header closeButton>
                    <Modal.Title>¡Contraseña actualizada!</Modal.Title>
                </Modal.Header>
                <Modal.Body>Ingresa con tu nueva contraseña :)</Modal.Body>
            </Modal>
            }
            <Modal show={modalMfaActivatedSuccessfully} onHide={() => setModalSuccess(false)} animation={false} >
                <Modal.Header closeButton>
                    <Modal.Title>¡Segundo factor de autenticación activado!</Modal.Title>
                </Modal.Header>
                <Modal.Body>Ya podés ingresar a la app!</Modal.Body>
            </Modal>
            {modal2fa && mfaData && 
                <Modal2FA 
                    show={modal2fa} 
                    onClose={() => setModal2fa(false)}
                    mfaTokenData={mfaData}
                    activated={activated}
                    onSuccess={() => { 
                        setLoading(false);
                        setModal2fa(false); 
                        if(!activated){
                            setModalSuccess(true);
                        }
                        else{
                            successfulLogin(jwt);
                        }
                    }}
                    onError={(mensaje) => {             
                        setLoading(false);
                        setFetchError(mensaje);
                        setModalError(true);     
                    }}
                />
            }
            {/* Loading */}
            {loading && <div className='loading vh-100 vw-100 z-3 position-absolute d-flex flex-column align-items-center justify-content-center'>
                <Oval
                    visible={true}
                    height="80"
                    width="80"
                    color="#fff"
                    ariaLabel="oval-loading"
                    wrapperStyle={{}}
                    wrapperClass=""
                />
                <p className='text-white fw-medium'>Loading...</p>
            </div>}
            <div className="login vh-100 d-flex align-items-center justify-content-center">
                <div className="login__container d-flex flex-row bg-white shadow-sm rounded">
                    <div className="login__container__form col-12 col-md-6 d-flex flex-column align-items-center justify-content-center">
                        <img className="login__container__form__img mb-4" src={Logo} alt="Logo" />
                        <form className="w-100 d-flex flex-column align-items-center" onSubmit={handleSubmit} autoComplete="on">
                            <div className="w-100 d-flex flex-column mb-3">
                                <label htmlFor="email" className="form-label">Correo</label>
                                <input 
                                    onChange={handleChange} 
                                    type="email" 
                                    id="email" 
                                    name="email" 
                                    autoComplete='username'
                                    placeholder="ejemplo@correo.com.ar" 
                                    className="form-control"
                                    value={formData.email}
                                />
                                {errors.email && <span className='form__error d-flex flex-row align-items-center px-1 my-1'><i className="bi bi-exclamation-circle me-1"></i>{errors.email}</span>}
                            </div>
                            <div className='w-100 d-flex flex-column mb-1'>
                                <label htmlFor="password" className='form-label'>Contraseña</label>
                                <input 
                                    onChange={handleChange} 
                                    type="password" 
                                    id='password' 
                                    name="password" 
                                    placeholder='' 
                                    autoComplete='current-password'
                                    className='form-control'
                                    value={formData.password}
                                />
                                {errors.password && <span className='form__error d-flex flex-row align-items-center px-1 my-1'><i className="bi bi-exclamation-circle me-1"></i>{errors.password}</span>}
                            </div>
                            <Link className='textChangePassword text-decoration-none align-self-end text-blue-500 fw-medium mb-4' to='/validate-mail'>¿Olvidaste tu contraseña?</Link>
                            {error !== null && <div className='mb-4'><i className="bi bi-exclamation-circle pe-2 text-danger"></i><span className='text-danger'>{error}</span></div>}
                            <button className="btn btn-primary" type='submit'>Iniciar Sesión</button>
                        </form>
                    </div>
                    <div className='login__container__info d-none d-md-flex flex-column justify-content-center col-md-6 bg-gray-100 rounded-end'>
                        <h1 className="login__container__info__title mb-2">Muchos pueden mirar, pero pocos pueden ver.</h1>
                        <h4 className="login__container__info__subtitle mb-4">Plataforma de Gestión profesional y seguimiento con datos.</h4>
                        <img src={Ilustration} alt="" />
                    </div>
                </div>
            </div>
        </>
    )
}

export default Login